var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgValidationCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Validation_-_check",
    "data-name": "Validation - check",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Validation_-_check-2",
    "data-name": "Validation - check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M12,23A11,11,0,1,1,23,12,11,11,0,0,1,12,23Z",
    transform: "translate(-1 -1)",
    fill: "#3e6c43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M10,17a1,1,0,0,1-.71-.29l-3-3a1,1,0,0,1,1.42-1.42L10,14.59l5.79-5.8a1,1,0,0,1,1.42,1.42l-6.5,6.5A1,1,0,0,1,10,17Z",
    transform: "translate(-1 -1)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidationCheck);
export default __webpack_public_path__ + "static/media/Validation - check.8cd66550ecb756a42b3eb06f87c9a3e1.svg";
export { ForwardRef as ReactComponent };